import { GetProductModelResource } from "@/api/generated-api";
import { formattedPrice } from "@/utils/formatters";
import { makeAutoObservable } from "mobx";

export class CatalogDetailStore {
  basePrice = 0;

  selectedOptionIds: Record<number, number> = {};

  optionPrices: Record<number, Record<number, number>> = {};

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  syncProduct = (product: GetProductModelResource) => {
    this.basePrice = product.price;

    this.selectedOptionIds = product.options.reduce<Record<number, number>>((acc, variant) => {
      acc[variant.id] = variant.items[0]?.id;
      return acc;
    }, {});

    this.optionPrices = product.options.reduce<Record<number, Record<number, number>>>((acc, variant) => {
      acc[variant.id] = Object.fromEntries(variant.items.map(item => [item.id, item.price])) as Record<number, number>;
      return acc;
    }, {});
  };

  selectOption = (variantId: number, itemId: number) => {
    this.selectedOptionIds = {
      ...this.selectedOptionIds,
      [variantId]: itemId,
    };
  };

  getSelectedOptionId = (variantId: number): number | undefined => this.selectedOptionIds[variantId];

  get totalPrice(): number | null {
    const optionsPrice = Object.entries(this.selectedOptionIds).reduce((total, [variantId, itemId]) => {
      const variantPrices = this.optionPrices[Number(variantId)];
      return total + (variantPrices?.[itemId] ?? 0);
    }, 0);

    return this.basePrice + optionsPrice;
  }

  get formattedPrice(): string {
    return formattedPrice(this.totalPrice ?? this.basePrice);
  }
}
